import { compose } from '@smartsheet-dataflow/formjs';
import { withFormJSDisabled } from './WithFormJSDisabled/withFormJSDisabled';
import { withFormJSHidden } from './WithFormJSHidden/withFormJSHidden';
import { withFormJSLabel } from './WithFormJSLabel/withFormJSLabel';
import { withFormJSReadonly } from './WithFormJSReadonly/withFormJSReadonly';
import { withFormJSTitle } from './WithFormJSTitle/withFormJSTitle';
import { withFormJSValue } from './WithFormJSValue/withFormJSValue';

export const withFormJSDefaults = compose(
  withFormJSDisabled,
  withFormJSReadonly,
  withFormJSHidden,
  withFormJSTitle,
  withFormJSLabel,
  withFormJSValue
);
